import { registerPlugin } from "@capacitor/core";
import { signedPost } from "./signedRequest";
import { loadIdentity } from "./identity";
import { devDebug } from "./devLog";
import { OPEN_DM_NOTIFICATION_EVENT } from "../hooks/useUnreadDmCount";

const PushBridge = registerPlugin("PushBridge");

function openTarget(data = {}) {
  const peerId = String(data.peerId || "").trim();
  if (peerId) {
    window.dispatchEvent(new CustomEvent(OPEN_DM_NOTIFICATION_EVENT, { detail: { peerId } }));
    return;
  }
  const postId = String(data.postId || "").trim();
  const topicSlug = String(data.topicSlug || "").trim();
  if (!postId) return;
  const url = new URL(window.location.href);
  url.searchParams.set("post", postId);
  if (topicSlug) url.searchParams.set("topic", topicSlug);
  window.location.assign(url.toString());
}

export async function startNativePush() {
  if (!window.Capacitor?.isNativePlatform?.()) return;
  const identity = loadIdentity();
  if (!identity?.identityId) return;
  try {
    const { token } = await PushBridge.getToken();
    if (token) {
      const register = () => signedPost("/api/v1/push/tokens", {
        token,
        platform: window.Capacitor.getPlatform?.() || "android",
      });
      try {
        await register();
      } catch {
        // The public session renewal runs in parallel at startup. Retry once
        // after it has had time to finish, without disturbing the user.
        await new Promise((resolve) => window.setTimeout(resolve, 2500));
        await register();
      }
    }
    const launch = await PushBridge.getLaunchTarget();
    if (launch && Object.keys(launch).length) {
      window.setTimeout(() => openTarget(launch), 250);
    }
    await PushBridge.addListener("notificationAction", (event) => openTarget(event || {}));
  } catch (error) {
    devDebug("native push unavailable", error?.message);
  }
}
